import React, { useState, useEffect } from 'react'
import AppName from './AppName'
import Container from '../Container'
import Logo from '../Logo'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { ThemeContext } from '../Theme'
import styles from './Header.module.scss'
import { useAuthState } from '../../components/AuthProvider'
import ProfileHeader from '../ProfileHeader'
import authProvider from '../AuthProvider/ActivateDirectoryAuthProvider'
import HeaderLinks from '../HeaderLinks'
import { useAuth } from '../AuthProvider'
import Menu from '../Menu'
import ListIncidentRequest from '../../pages/ServiceNow/ListIncidentRequest'
import Timeout from '../Timeout/Timeout'
import { tickToTimeStamp } from '../../utils/tickToTimeStamp'

const Header = ({ appName, children = null, logoUrl }) => {
  const theme = React.useContext(ThemeContext)
  const history = useNavigate()
  const [{ isAuthenticated, user, authMode }] = useAuth()

  const [showInfoDialog, setShowInfoDialog] = useState(false)
  function formOpen() {
    setShowInfoDialog((current) => !current)
  }
  const sendDataToParent = () => {
    setShowInfoDialog((current) => !current)
  }

  return (
    <>
      {' '}
      <header className={`${styles.base} ${styles[theme]}`}>
        <Container className={styles.container}>
          <div className={styles.sideLogo}>
            <a className={`${styles.logo} ${styles.pointer}`} href={logoUrl}>
              <Logo />
            </a>
            {appName && <AppName>{appName}</AppName>}
          </div>

          {children && <div className={styles.items}>{children}</div>}
          {isAuthenticated && (
            <div className={styles.rightMenu}>
              <div role="button" tabindex="0"
                className={styles.aboutMenu}
                onClick={() => {
                  window.location.href = "/about";
                }}
                onKeyUp={(event)=>{
                  event.key=== "Enter"?history('/about'):history('')
                }}
              >
                <p>About</p>
              </div>
              <div className={styles.nameInitials}>
                <p>{user.sortName}</p>
              </div>
              <div className={styles.signDiv}>
                <ProfileHeader>
                  <HeaderLinks>
                    {isAuthenticated ? (
                      <>
                        <HeaderLinks.Item
                          label={user.firstName + ' ' + user.lastName}
                         tabIndex={0}
                        >
                          <Menu menutype="profile" >
                            <Menu.Item
                              label="Reported Issue"
                              onClick={formOpen}
                              tabIndex={0}
                            />
                            <div
                              style={{
                                border: '1px solid #F4F4F4',
                                marginLeft: '19px',
                                marginRight: '18px',
                              }}
                              tabIndex={-1}
                            ></div>
                            {authProvider && (authMode === 'ohid'|| authMode === 'msid' )? (
                              <Menu.Item
                                render={() => (
                                  <Link
                                    style={{ textAlign: 'right' }}
                                    to="/signout"
                                     tabIndex={0}
                                  >
                                    Sign Out
                                  </Link>
                                )}
                                 tabIndex={0}
                              />
                            ) : (
                              <Menu.Item
                                render={() => (
                                  <Link style={{ textAlign: 'right' }}  tabIndex={0} to="/">
                                    Sign Out
                                  </Link>
                                )}
                                 tabIndex={0}
                              />
                            )}
                          </Menu>
                        </HeaderLinks.Item>
                      </>
                    ) : (
                      <HeaderLinks.Item
                        render={() => <Link to="/">Sign In</Link>}
                      />
                    )}
                  </HeaderLinks>
                </ProfileHeader>
                <Timeout
                  endTime={
                    localStorage.getItem('exp')
                      ? tickToTimeStamp(+localStorage.getItem('exp'))
                      : Date.now() + 30 * 60 * 1000
                  }
                  showCountDownDuration={300000}
                  redirectPath={'/signout'}
                />
              </div>
            </div>
          )}
        </Container>
      </header>
      {showInfoDialog && isAuthenticated && (
        <ListIncidentRequest
          key={'data'}
          istrue={showInfoDialog}
          sendDataToParent={sendDataToParent}
        />
      )}
    </>
  )
}

export default Header
